import React, { useMemo } from "react";

import SearchableSingleValueField from "./SearchableSingleValueField";
import {
  buildCompanySizeOptions,
  normalizeCompanySizeValue,
} from "../utils/companySizeOptions";

export default function CompanySizeDropdownField({
  value = "",
  onChange,
  options = [],
  placeholder = "50 - 200 employees",
  loading = false,
  onInputValueChange,
  textFieldProps = {},
  autocompleteProps = {},
  inputSx,
  freeSoloCommitKeys,
}) {
  const normalizedValue = normalizeCompanySizeValue(value);
  const mergedOptions = useMemo(
    () => buildCompanySizeOptions([normalizedValue, ...(Array.isArray(options) ? options : [])]),
    [normalizedValue, options]
  );

  return (
    <SearchableSingleValueField
      value={normalizedValue}
      onChange={(nextValue) => onChange?.(normalizeCompanySizeValue(nextValue))}
      onInputValueChange={onInputValueChange}
      options={mergedOptions}
      placeholder={placeholder}
      loading={loading}
      normalizeInput={normalizeCompanySizeValue}
      textFieldProps={{ fullWidth: true, ...textFieldProps }}
      autocompleteProps={{
        openOnFocus: true,
        autoHighlight: true,
        forcePopupIcon: true,
        ...autocompleteProps,
      }}
      inputSx={inputSx}
      freeSoloCommitKeys={freeSoloCommitKeys}
    />
  );
}
